import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Skeleton } from "@/components/ui/skeleton";

interface EntityFilesSectionProps<T> {
  /** Режим загрузки файла (MinIO); иначе — ручной ID. */
  mode?: "fileId" | "upload";
  addPlaceholder?: string;
  addValue?: string;
  onAddValueChange?: (value: string) => void;
  onAdd?: () => void;
  onUploadFile?: (file: File) => void;
  addPending?: boolean;
  isLoading?: boolean;
  items: T[];
  getKey: (item: T) => number;
  renderColumns: (item: T) => React.ReactNode;
  onDelete: (item: T) => void;
  onDownload?: (item: T) => void;
  deletePending?: boolean;
  emptyText?: string;
}

export function EntityFilesSection<T>({
  mode = "fileId",
  addPlaceholder = "ID файла",
  addValue = "",
  onAddValueChange,
  onAdd,
  onUploadFile,
  addPending = false,
  isLoading = false,
  items,
  getKey,
  renderColumns,
  onDelete,
  onDownload,
  deletePending = false,
  emptyText = "Материалы не добавлены",
}: EntityFilesSectionProps<T>) {
  return (
    <div className="space-y-3">
      {mode === "upload" ? (
        <div className="flex gap-2 items-center">
          <Input
            type="file"
            disabled={addPending}
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file && onUploadFile) onUploadFile(file);
              e.target.value = "";
            }}
          />
          {addPending ? (
            <span className="text-xs text-muted-foreground shrink-0">Загрузка…</span>
          ) : null}
        </div>
      ) : (
        <div className="flex gap-2">
          <Input
            placeholder={addPlaceholder}
            value={addValue}
            onChange={(e) => onAddValueChange?.(e.target.value)}
          />
          <Button onClick={onAdd} disabled={addPending}>
            Добавить
          </Button>
        </div>
      )}

      <div className="border rounded-md">
        {isLoading ? (
          <div className="p-3">
            <Skeleton className="h-10 w-full" />
          </div>
        ) : items.length === 0 ? (
          <div className="p-3 text-sm text-muted-foreground">{emptyText}</div>
        ) : (
          items.map((item) => (
            <div
              key={getKey(item)}
              className="grid grid-cols-[1fr_auto] gap-2 px-3 py-2 border-b text-sm items-center"
            >
              <div className="min-w-0">{renderColumns(item)}</div>
              <div className="flex gap-1 shrink-0">
                {onDownload ? (
                  <Button size="sm" variant="outline" onClick={() => onDownload(item)}>
                    Скачать
                  </Button>
                ) : null}
                <Button
                  size="sm"
                  variant="destructive"
                  onClick={() => onDelete(item)}
                  disabled={deletePending}
                >
                  Удалить
                </Button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
